import Vue from 'vue'
import Router from 'vue-router'
import common from '@/mixins/common'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: (resolve) => {
        require(['@/views/login/login'], resolve)
      },
    },
    {
      path: '/master',
      component: (resolve) => {
        require(['@/views/master/index'], resolve)
      },
      children: [
        {
          path: '/',
          name: 'home',
          component: (resolve) => {
            require(['@/views/master/home'], resolve)
          },
        },
        {
          path: 'member',
          name: 'member',
          component: (resolve) => {
            require(['@/views/master/member'], resolve)
          },
        },
        {
          path: 'scene',
          name: 'scene',
          component: (resolve) => {
            require(['@/views/master/scene'], resolve)
          },
        },
        {
          path: 'bill',
          name: 'bill',
          component: (resolve) => {
            require(['@/views/master/bill'], resolve)
          },
        },
        {
          path: 'log',
          name: 'log',
          component: (resolve) => {
            require(['@/views/master/log'], resolve)
          },
        },
      ],
    }
  ]
})
//后端控制登录
router.beforeEach((to, from, next) => {
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js